import React from 'react';
import { Box, Typography, ButtonBase } from '@mui/material';
import moment from 'moment';
import color from '@/styles/mobile/color';
import { MainText } from '../../../components/UI/mobile/ui';

const uiColor = color.ui;

const BillItem = ({ bill, setCurrentBill, setCurrentPage }) => {
  const status = {
    0: { name: '未繳費', color: '#CC771C' },
    1: { name: '已繳費', color: '#103F60' },
    2: { name: '逾期', color: '#A83C38' },
    3: { name: '未入帳', color: '#8B8B8B' },
  };
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        py: '3vw',
        '@media (orientation: landscape)': {
          py: '1.5vw',
        },
      }}
    >
      <MainText>{moment(bill.billTime).format('YYYY-MM')}</MainText>
      <Typography
        sx={{
          fontSize: '3.6vw',
          lineHeight: '6.2vw',
          bgcolor: status[bill.status].color,
          textAlign: 'center',
          height: '6.2vw',
          width: '15.6vw',
          color: '#FFFFFF',
          borderRadius: '1vw',
          marginLeft: '10vw',
          '@media (orientation: landscape)': {
            fontSize: '1.8vw',
            lineHeight: '3vw',
            height: '3vw',
            width: '8vw',
            borderRadius: '0.4vw',
            marginLeft: '17vw',
          },
        }}
      >
        {status[bill.status].name}
      </Typography>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-end',
          '& > *:not(:last-child)': {
            marginRight: '1.8vw',
          },
          flexGrow: 1,
          '@media (orientation: landscape)': {
            '& > *:not(:last-child)': {
              marginRight: '4.6vw',
            },
          },
        }}
      >
        <MainText>{`＄${bill.money.toLocaleString()}元`}</MainText>
        <ButtonBase
          disableRipple
          sx={{
            border: `0.2vw solid ${uiColor.divider}`,
            borderRadius: '0.8vw',
            width: '16vw',
            height: '6.2vw',
            fontSize: '3.6vw',
            lineHeight: '6.2vw',
            textAlign: 'center',
            color: uiColor.divider,
            '&:active': {
              color: uiColor.textLight,
              bgcolor: uiColor.divider,
            },
            '@media (orientation: landscape)': {
              fontSize: '1.8vw',
              lineHeight: '3vw',
              height: '3vw',
              width: '8vw',
              borderRadius: '0.4vw',
              borderWidth: '0.1vw',
            },
          }}
          onClick={() => {
            setCurrentBill(bill);
            setCurrentPage('detail');
          }}
        >
          看明細
        </ButtonBase>
      </Box>
    </Box>
  );
};

export default BillItem;
